//src/types/Helper/Interfaces.ts

export interface ObjectSummary {
  id: string
  name: string
  active: boolean
}

export interface TabItem {
  text: string
  value: string
  icon: string
  adminOnly?: boolean // Optional property for admin-only tabs
}

export interface TabContent {
  value: string
  component: any
  //props?: Record<string, any> // Optional additional props for the component
}

export interface ViewTabContent {
  title: string
  data: Object
}

export interface fAAMaster {
  'KIT MODEL': string
  'AIR WORTH DATE': string
  'CERT ISSUE DATE': string
  CERTIFICATION: string
  CITY: string
  COUNTRY: string
  COUNTY: string
  'ENG MFR MDL': string
  'EXPIRATION DATE': string
  'FRACT OWNER': string
  'KIT MFR': string
  'LAST ACTION DATE': string
  'MFR MDL CODE': string
  'MODE S CODE': string
  'MODE S CODE HEX': string
  'N-NUMBER': string
  NAME: string
  'OTHER NAMES(1)': string
  'OTHER NAMES(2)': string
  'OTHER NAMES(3)': string
  'OTHER NAMES(4)': string
  'OTHER NAMES(5)': string
  REGION: string
  'SERIAL NUMBER': string
  STATE: string
  'STATUS CODE': string
  STREET: string
  STREET2: string
  'TYPE AIRCRAFT': string
  'TYPE ENGINE': string
  'TYPE REGISTRANT': string
  'UNIQUE ID': string
  'YEAR MFR': string
  'ZIP CODE': string
}

export interface fAAACFTREF {
  'AC-CAT': string
  'AC-WEIGHT': string
  'BUID-CERT-IND': string
  CODE: string
  MFR: string
  MODEL: string
  'NO-ENG': string
  'NO-SEATS': string
  SPEED: string
  'TC-DATA-HOLDER': string
  'TC-DATA-SHEET': string
  'TYPE-ACFT': string
  'TYPE-ENG': string
}

export interface fAAEngine {
  CODE: string
  HORSEPOWER: string
  MFR: string
  MODEL: string
  THRUST: string
  TYPE: string
}

export interface personNotifications {
  name: string
  notificationTypes: notif[]
}

export interface notif {
  type: string
  hasNotification: boolean
}

export interface CurrentFinance {
  balance: number
}

export function createCurrentFinance(init: Partial<CurrentFinance> = {}): CurrentFinance {
  return {
    balance: 0,
    ...init
  }
}
